<div class="background" [ngStyle]="{ 'background-image': 'url(' + (cloud?.configuration?.backgroundUrl || '') + ')' }"></div>
<div class="container">
  <router-outlet></router-outlet>
</div>
